import React from 'react'
import {injectIntl} from 'react-intl'
import styled from 'styled-components'
import Button from '@mui/material/Button'
import Selector from 'components/Selector'
import Item from './Item'

const FieldsList = styled.div`
    margin-bottom: 30px;
`

const Empty = styled.div`
    height: 70px;
    align-items: center;
    padding: 0 20px;
    display: flex;
    border: none;
    box-shadow: 0 1px 3px 0 rgba(179, 216, 225, .5);
    background: #FFF;
`

class PublicFields extends React.Component {
    constructor(props) {
        super(props)

        this.list = React.createRef()

        this.onDragStart = this.onDragStart.bind(this)
        this.onDragMove = this.onDragMove.bind(this)
        this.onDragEnd = this.onDragEnd.bind(this)

        this.state = {
            id: null
        }
    }

    onDragStart(e, id) {
        e.preventDefault()

        const sections = document.querySelectorAll('section')
        sections.forEach(item => item.classList.add('reorder'))

        this.order = [...this.props.order]

        this.setState({
            id
        })

        this.calculateDragParameters(e, id)
        this.calculateCoordinates(id)
        this.dragModule = document.querySelector(`[data-drag-field='${id}']`)
        this.dragModule.style.opacity = '0.5'

        document.addEventListener('mousemove', this.onDragMove)
        document.addEventListener('mouseup', this.onDragEnd)

        this.onDragMove(e)
    }

    onDragMove(e) {
        e.preventDefault()
        e.stopPropagation()

        let top = e.pageY - this.drag.relY - this.drag.top

        if (this.drag.min > top) {
            top = this.drag.min
        }

        if (this.drag.max < top) {
            top = this.drag.max
        }

        this.dragModule.style.transform = `translate3d(0px, ${top}px, 0px)`

        const bottom = top + this.drag.cellHeight

        if (this.drag.elTop && top < this.drag.markerTop) {
            this.swapColumns(this.drag.elTop, false)
        } else if (this.drag.elBottom && bottom > this.drag.markerBottom) {
            this.swapColumns(this.drag.elBottom, true)
        }
    }

    getOrder(arr, order) {
        return arr.sort((a, b) => {
            let indexA = order.indexOf(a.fieldId)
            let indexB = order.indexOf(b.fieldId)

            return indexA - indexB
        })
    }

    onDragEnd(e) {
        e.preventDefault()

        const sections = document.querySelectorAll('section')
        sections.forEach(item => item.classList.remove('reorder'))

        const els = document.querySelectorAll('[data-drag-field]')
        els.forEach(item => item.style.transform = '')

        if (JSON.stringify(this.order) !== JSON.stringify(this.props.order)) {
            const fields = this.getOrder(this.props.list, this.order)

            this.props.onReorder(fields, this.order)
        }

        this.order = null

        document.removeEventListener('mousemove', this.onDragMove)
        document.removeEventListener('mouseup', this.onDragEnd)

        this.dragModule.style.opacity = ''
    }

    calculateDragParameters(e, draggableId) {
        const container = this.list.current.getBoundingClientRect()
        const cell = document.querySelector(`[data-drag-field='${draggableId}']`).getBoundingClientRect()
        const min = container.top - cell.top
        const max = container.height - cell.height + min

        this.drag = {
            top: cell.top,
            min: min,
            max: max,
            relY: e.pageY - cell.top,
            cellHeight: cell.height
        }
    }

    swapColumns(targetId, direction) {
        const trgtEls = document.querySelector(`[data-drag-field='${targetId}']`)
        const transform = (this.drag.cellHeight) * (direction ? -1 : 1)

        if (trgtEls.style.transform) {
            trgtEls.style.transform = ''
        } else {
            trgtEls.style.transform = `translate3d(0px, ${transform}px, 0px)`
        }

        const targetIndex = this.order.indexOf(targetId)
        this.order[this.order.indexOf(this.state.id)] = targetId
        this.order[targetIndex] = this.state.id

        this.calculateCoordinates(this.state.id)
    }

    calculateCoordinates(draggableId) {
        if (draggableId) {
            const itemPosition = this.order.indexOf(draggableId)

            /* Calculate Left Marker */
            this.drag.elTop = null
            if (itemPosition) {
                this.drag.elTop = this.order[itemPosition - 1]
                this.drag.markerTop = this.getColumnMarker(this.drag.elTop)
                if (!this.drag.markerTop === null) {
                    this.drag.elTop = null
                }
            }
            /* Calculate Right Marker */
            this.drag.elBottom = null
            if (itemPosition !== this.order.length - 1) {
                this.drag.elBottom = this.order[itemPosition + 1]
                this.drag.markerBottom = this.getColumnMarker(this.drag.elBottom)
                if (this.drag.markerBottom === null) {
                    this.drag.elBottom = null
                }
            }
        }
    }

    getColumnMarker(elId) {
        const el = document.querySelector(`[data-drag-field='${elId}']`)
        if (el) {
            const box = el.getBoundingClientRect()
            return box.top - this.drag.top + (box.height / 2)
        }
        return null
    }

    render() {
        const { intl, data } = this.props
        const fields = this.props.list.filter(obj => !obj.subtitle)
        
        return (
            <React.Fragment>
                <FieldsList ref={this.list}>
                    {!this.props.list.length &&
                        <Empty>{intl.formatMessage({id: "sidebar.no_fields"})}</Empty>
                    }
                    {this.props.list.map((item, index) =>
                        <Item
                            autocomplete={item.autocomplete}
                            optional={item.optional}
                            recipient={item.recipient}
                            now={item.now}
                            readonly={item.readonly}
                            mandatory={item.mandatory}
                            subtitle={item.subtitle}
                            config={!item.subtitle ? data.find(col => col.id === item.fieldId).uiConfig : null}
                            key={item.fieldId}
                            type={!item.subtitle ? data.find(col => col.id === item.fieldId).uiType : null}
                            name={!item.subtitle ? data.find(col => col.id === item.fieldId).singular : null}
                            label={item.label}
                            id={item.fieldId}
                            handleChange={this.props.handleChange}
                            values={this.props.values[item.fieldId]}
                            deleteField={this.props.deleteField}
                            onDragStart={this.onDragStart}
                            options={this.props.options}
                        />
                    )}
                </FieldsList>
                <Selector
                    data={data.filter(el =>
                        !this.props.list.find(field => field.fieldId === el.id)).map(item => {
                            return {
                                name: item.singular,
                                id: item.id,
                                type: item.uiType
                            }
                        }
                    )}
                    disabled={fields.length === data.length}
                    handleSelect={this.props.handleSelect}
                    text='sidebar.add_field'
                />
               {this.props.isForm &&
					<Button
						variant="contained"
						onClick={this.props.handleClick}
						style={{background: '#fdc22d', color: '#fff', marginLeft: '8px'}}
					>
						{intl.formatMessage({id: 'sidebar.add_subtitle'})}
					</Button>
				}
            </React.Fragment>
        )
    }
}

export default injectIntl(PublicFields)
